import i18n from './index';

/**
 * Generates a document title in the format "{title} | Kognitos"
 * @param title - The page title string
 * @returns Formatted document title
 */
export function getDocumentTitle(title: string): string {
  return `${title} | Kognitos`;
}

/**
 * Changes the current language and persists it to localStorage
 * @param language - Language code (e.g., 'en', 'te')
 */
export function changeLanguage(language: string): void {
  i18n.changeLanguage(language);
}

/**
 * Gets the current language
 * @returns Current language code
 */
export function getCurrentLanguage(): string {
  return i18n.language;
}

/**
 * Gets all available languages
 * @returns Array of language codes
 */
export function getAvailableLanguages(): string[] {
  return Object.keys(i18n.options.resources || {});
}

/**
 * Language display names mapping
 */
export const languageNames: Record<string, string> = {
  en: 'English',
};

/**
 * Gets the display name for a language code
 * @param languageCode - Language code (e.g., 'en', 'te')
 * @returns Display name for the language
 */
export function getLanguageDisplayName(languageCode: string): string {
  return languageNames[languageCode] || languageCode;
}
